/**
 * Settings screen — volume controls and visual options.
 */

import type { GameSettings } from '@/storage/save-data';

export class SettingsScreen {
  private element: HTMLElement | null = null;
  onClose: (() => void) | null = null;
  onChange: ((settings: Partial<GameSettings>) => void) | null = null;

  show(settings: GameSettings): void {
    this.hide();

    const el = document.createElement('div');
    el.id = 'settings-screen';
    el.style.cssText = `
      position: fixed; top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(10, 10, 26, 0.92);
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      z-index: 60; backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      font-family: 'Courier New', monospace;
    `;

    el.innerHTML = `
      <div style="color: #00ffff; font-size: clamp(1.2rem, 4vw, 1.8rem); font-weight: bold;
                  text-shadow: 0 0 20px #00ffff, 0 0 40px #00ffff44;
                  letter-spacing: 0.15em; margin-bottom: 1.5rem;">
        SETTINGS
      </div>
      <div style="width: 260px; max-width: 85vw;">
        ${this.sliderRow('Master Volume', 'masterVolume', settings.masterVolume)}
        ${this.sliderRow('Music Volume', 'musicVolume', settings.musicVolume)}
        ${this.sliderRow('SFX Volume', 'sfxVolume', settings.sfxVolume)}
      </div>
      <button id="settings-close" class="menu-btn" style="margin-top: 1.5rem; width: 160px;">
        DONE
      </button>
    `;

    document.body.appendChild(el);
    this.element = el;

    // Slider change handlers
    el.querySelectorAll('input[type=range]').forEach((input) => {
      input.addEventListener('input', () => {
        const key = (input as HTMLInputElement).dataset.key as keyof GameSettings;
        const val = parseFloat((input as HTMLInputElement).value);
        const label = el.querySelector(`[data-val="${key}"]`);
        if (label) label.textContent = Math.round(val * 100) + '%';
        this.onChange?.({ [key]: val });
      });
    });

    const stopProp = (e: Event) => e.stopPropagation();
    el.querySelector('#settings-close')?.addEventListener('pointerdown', (e) => {
      stopProp(e);
      this.hide();
      this.onClose?.();
    });
  }

  hide(): void {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }

  private sliderRow(label: string, key: string, value: number): string {
    return `
      <div style="margin: 12px 0;">
        <div style="display: flex; justify-content: space-between; color: #aaeeff;
                    font-size: 0.85rem; margin-bottom: 4px;">
          <span>${label}</span>
          <span data-val="${key}">${Math.round(value * 100)}%</span>
        </div>
        <input type="range" data-key="${key}" min="0" max="1" step="0.05"
               value="${value}"
               style="width: 100%; accent-color: #00ffff; cursor: pointer;">
      </div>
    `;
  }
}
